import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PageLoader from './components/common/PageLoader';

import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <PageLoader>
        <App />
    </PageLoader>
  </HelmetProvider>
);
